import { useMemo, forwardRef } from "react";
import { Shape } from "three";
import { degToRad } from "three/src/math/MathUtils";

const RoundedQuadGeometry = forwardRef(
  ({ radius = 0.25, lenght = 2, width = 1, height = 0.25, curveSegments = 32, ...props }, ref) => {
    const shape = useMemo(() => {
      const shape = new Shape();
      const flatSideLength = lenght - 2 * radius;
      const halfSideLength = flatSideLength / 2;
      const flatSideWidth = width - 2 * radius;
      const halfSideWidth = flatSideWidth / 2;

      shape.moveTo(-lenght / 2, halfSideWidth);
      // shape.lineTo(-halfSideLength, lenght / 2);
      shape.absarc(-halfSideLength, halfSideWidth, radius, degToRad(180), degToRad(90), true);
      shape.lineTo(halfSideLength, width / 2);
      shape.absarc(halfSideLength, halfSideWidth, radius, degToRad(90), degToRad(0), true);
      shape.lineTo(lenght / 2, -halfSideWidth);
      shape.absarc(halfSideLength, -halfSideWidth, radius, degToRad(0), degToRad(270), true);
      shape.lineTo(-halfSideLength, -width / 2);
      shape.absarc(-halfSideLength, -halfSideWidth, radius, degToRad(270), degToRad(180), true);

      shape.closePath();

      return shape;
    }, [radius, lenght, width, height, curveSegments]);

    return (
      <extrudeGeometry
        center={true}
        ref={ref}
        args={[
          shape,
          {
            steps: 1,
            curveSegments: curveSegments,
            depth: height,
            bevelEnabled: true,
            bevelThickness: 0.021,
            bevelSize: 0.021,
            bevelOffset: 0,
            bevelSegments: 6,
          },
        ]}
      />
    );
  },
);

export default RoundedQuadGeometry;
